import { Component } from '@angular/core';

@Component({
  selector: 'instructions-la',
  templateUrl: './instructions-la.html',
})
export class InstructionsLA {}
